import { combineReducers, Action } from "@reduxjs/toolkit";
import { authApi } from "redux/services/auth";
import { membershipApi } from "redux/services/membership";
import { dataLoaderApi } from "redux/services/dataLoader";
import { externalApi } from "redux/services/external";
import { documentApi } from "redux/services/documentRepository";
import { approvalProcessorApi } from "redux/services/approvalProcessor";
import { approvalRuleApi } from "redux/services/approvalRule";
import { auditApi } from "redux/services/auditRecord";
import { indetityApi, indetityApiAppToken, setPasswordApiAppToken } from "redux/services/identity";
import authReducer, { logout } from "redux/slices/authSlice";
import errorReducer from "redux/slices/errorSlice";

const combinedReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  auth: authReducer,
  error: errorReducer,
  [membershipApi.reducerPath]: membershipApi.reducer,
  [dataLoaderApi.reducerPath]: dataLoaderApi.reducer,
  [externalApi.reducerPath]: externalApi.reducer,
  [documentApi.reducerPath]: documentApi.reducer,
  [approvalProcessorApi.reducerPath]: approvalProcessorApi.reducer,
  [approvalRuleApi.reducerPath]: approvalRuleApi.reducer,
  [auditApi.reducerPath]: auditApi.reducer,
  [indetityApi.reducerPath]: indetityApi.reducer,
  [indetityApiAppToken.reducerPath]: indetityApiAppToken.reducer,
  [setPasswordApiAppToken.reducerPath]: setPasswordApiAppToken.reducer,
  [auditApi.reducerPath]: auditApi.reducer,
});

const rootReducer = (state: any, action: Action) => {
  // clear store after logout
  if (action.type === logout.toString()) {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export default rootReducer;
